module.exports = __webpack_public_path__ + "static/img/bus-content-6.6e21d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-6.png
// module id = fB6E
// module chunks = 0